import { debounce } from './utils/utils';

document.querySelectorAll('.tarifftabs_24-block').forEach(block => {
  let activeMainNavItem = block.querySelector('.tariff-nav-item.active');
  let activeSubNavItem = activeMainNavItem.querySelector('.sub-nav-item.active');
  const allTariffCards = block.querySelectorAll('.tariff-cards');
  let activeTariffCards = block.querySelector('.tariff-cards.active');
  const tariffHeadline = block.querySelector('.tariff-cards-container > p');

  const updateActiveItem = (prevAct, newAct) => {
    prevAct.classList.remove('active');
    newAct.parentNode.classList.add('active');
    return newAct.parentNode;
  };

  block.querySelectorAll('.tariff-nav-item > button').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      activeMainNavItem = updateActiveItem(activeMainNavItem, link);
      setSubNavAndBlock(activeMainNavItem.querySelector('.sub-nav-item'));
    });
  });

  block.querySelectorAll('.sub-nav-item > button').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      activeSubNavItem = updateActiveItem(activeSubNavItem, link);
      setSubNavAndBlock(activeSubNavItem);
    });
  });

  const setSubNavAndBlock = item => {
    // Update sub nav item
    activeSubNavItem.classList.remove('active');
    activeSubNavItem = item;
    activeSubNavItem.classList.add('active');

    // Update tariff cards container
    activeTariffCards.classList.remove('active');
    allTariffCards.forEach(cards => {
      if (activeSubNavItem.querySelector('button').getAttribute('data-job-status').replace('#', '') === cards.getAttribute('id')) {
        const allCards = cards.querySelectorAll('.tariff-card');
        let timeOut = 0;
        for (const card of allCards) {
          card.style.opacity = '0';
          card.style.transform = 'translateX(50px)';
          setTimeout(() => {
            card.style.opacity = '1';
            card.style.transform = 'translateX(0)';
          }, timeOut);
          timeOut += 150;
        }
        cards.classList.add('active');
        activeTariffCards = cards;
      } else {
        cards.querySelectorAll('.tariff-card').forEach(card => {
          card.style.removeProperty('opacity');
          card.style.removeProperty('transform');
        });
      }
    });

    // Update headline
    if (window.innerWidth > 991) {
      tariffHeadline.textContent = item.querySelector('button').getAttribute('data-headline');
    }
    setScroll();
  };

  const setScroll = () => {
    if (window.innerWidth > 991) {
      return;
    }
    const activeSubNavContainer = activeMainNavItem.querySelector('.user-group-nav-container');
    const activeSubNav = activeSubNavContainer.querySelector('.user-group-nav');
    const scrollContainer = activeMainNavItem.querySelector('.scroll-container');

    const cpasn = getComputedStyle(activeSubNav);
    const liItem = activeSubNav.querySelectorAll('li');
    let subNavWidth;
    subNavWidth = parseInt(cpasn.gap) * (liItem.length - 1);
    liItem.forEach(item => {
      subNavWidth += item.offsetWidth;
    });

    activeSubNavContainer.addEventListener('scroll', () => {
      setOpacity();
    });

    const setOpacity = () => {
      activeSubNavContainer.scrollLeft > 0 ? scrollContainer.style.setProperty('--left-opacity', 1) : scrollContainer.style.setProperty('--left-opacity', 0);
      activeSubNavContainer.scrollLeft + activeSubNavContainer.offsetWidth === subNavWidth
        ? scrollContainer.style.setProperty('--right-opacity', 0)
        : scrollContainer.style.setProperty('--right-opacity', 1);
    };
    setOpacity();
  };
  window.addEventListener('DOMContentLoaded', setScroll);
  window.addEventListener('resize', debounce(setScroll, 300));
});
